var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogomark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 60,
    viewBox: "0 0 64 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 30.0003C20.3398 30.0003 32 19.3118 32 0.666992C32 19.3118 43.6602 30.0003 64 30.0003C43.6602 30.0003 32 40.6889 32 59.3337C32 40.6889 20.3398 30.0003 0 30.0003Z",
    fill: "#101828"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogomark);
export default ForwardRef;